import { render, staticRenderFns } from "./IconForm.vue?vue&type=template&id=2b6a1c2e&"
import script from "./IconForm.vue?vue&type=script&lang=js&"
export * from "./IconForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports